import { createApp } from 'vue';

const app = createApp({});
export const eventBus = app;
